document.addEventListener('DOMContentLoaded', function() {

	// Settings.
	const vivaCookieConsent = document.querySelector('.viva-cookie-consent');
	const vivaCookieConsentAccept = document.querySelector('#viva-cookie-consent-accept');
	const vivaCookieConsentSaveSettings = document.querySelector('#viva-cookie-consent-save-settings');
	const vivaCookieConsentCheckboxes = document.querySelectorAll('input[name="viva_cookie_consent_level[]"]');

	// Display cookie consent dialog if age is not verified.
	const ageVerificationCookie = Cookies.get('age_verified');

	if (typeof ageVerificationCookie === 'undefined' || localStorage.getItem('viva_cookie_consent_level') === null) {

		// Show cookie consent.
		vivaCookieConsent.classList.add('viva-cookie-consent--visible');

		// Block page scroll.
		document.body.style.overflow = 'hidden';
	} else {
		loadAnalytics();
		loadMarketing();
	}

	// Handle accept button.
	vivaCookieConsentAccept.addEventListener('click', function(event) {
		saveAgeVerifiedCookie();
		saveCookieConsentLevel('2');
	});

	// Handle checkbox clicks.
	vivaCookieConsentCheckboxes.forEach((checkbox) => {
		checkbox.addEventListener('click', function(event) {
			if (event.target.value === '2') {
				document.querySelector('#viva_cookie_consent_level_1').checked = true;
			}
		});
	});

	// Handle save settings button.
	vivaCookieConsentSaveSettings.addEventListener('click', function(event) {

		saveAgeVerifiedCookie();

		var consentLevel = 0;
		var consentLevelsChecked = [];

		const consentCheckboxes = document.querySelectorAll('input[name="viva_cookie_consent_level[]"]');
		consentCheckboxes.forEach((checkbox) => {
			if (checkbox.checked) {
				consentLevelsChecked.push(checkbox.value);
			}
		});

		consentLevel = String(Math.max(...consentLevelsChecked));

		saveCookieConsentLevel(consentLevel);
	});

	// Hide cookie consent.
	function hideCookieConsent() {
		vivaCookieConsent.classList.remove('viva-cookie-consent--visible');
		document.body.style.overflow = '';
	}

	// Save age verified cookie.
	function saveAgeVerifiedCookie() {
		Cookies.set('age_verified', 'true');
	}

	// Save cookie consent level.
	function saveCookieConsentLevel(level) {
		localStorage.setItem('viva_cookie_consent_level', level);

		hideCookieConsent();

		if (level >= '1') {
			loadAnalytics();
		}

		if (level == '2') {
			loadMarketing();
		}
	}

	// Load analytics.
	function loadAnalytics() {

		// Google Analytics.
		if (typeof analyticsId !== 'undefined') {
			var script = document.createElement('script');
			script.src = "https://www.googletagmanager.com/gtag/js?id=" + analyticsId;
			document.getElementsByTagName('head')[0].appendChild(script);

			window.dataLayer = window.dataLayer || [];
			function gtag(){dataLayer.push(arguments);}
			gtag('js', new Date());
			gtag('config', analyticsId);
		}
	}

	// Load marketing.
	function loadMarketing() {

		if (typeof tagManagerId !== 'undefined') {
			(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
				new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
				j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
				'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
			})(window,document,'script','dataLayer',tagManagerId);
		}
	}
});
